var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeHidden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eye-hidden_svg__clip0_2764_7359)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.445.384C2.181.121 1.73.144 1.437.437c-.293.293-.316.745-.053 1.008L13.93 13.991c.263.263.715.24 1.007-.053.293-.293.317-.745.053-1.008l-2.657-2.658C13.125 9.343 13.6 8.406 13.6 8c0-.933-2.507-4.667-5.6-4.667-.73 0-1.428.208-2.068.539L2.445.384zm4.894 4.894l3.382 3.383A2.8 2.8 0 007.34 5.279zM5.199 8c0-.228.028-.45.08-.661L3.666 5.728C2.875 6.656 2.4 7.594 2.4 8c0 .933 2.507 4.667 5.6 4.667.73 0 1.428-.208 2.068-.539L8.66 10.722A2.8 2.8 0 015.2 8z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eye-hidden_svg__clip0_2764_7359"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
}

export default SvgEyeHidden;